<template>
  <WindowFrame
    class="ma-0 pa-0"
    :component="'check'"
    :input_args="input_args"
    :key="key_check"
    @update_view="hdlUpdateView"
    @loaded="handleCheckLoaded"
    ref="windowframe_check"
  />
</template>
  <script>
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

export default {
  name: "FrameCheckEsecuzioneDossier",
  components: { WindowFrame },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      input_args: {
        dizionario: new Object(),
        esterno: 0,
        toolbar_btn_chiudi: true,
        toolbar_visible: false,
      },
      key_check: 0,

      // Modal
      // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    hdlUpdateView() {
      this.key_check = this.key_check === 0 ? 1 : 0;
    },
    handleCheckLoaded() {
      this.$refs.windowframe_check.postEvent("setparams", {
        dizionario: new Object(),
        landing_page: "esecuzionedossier",
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
  <style scoped>
</style>